const steps = [
  {
    num: "01",
    icon: "ri-chat-3-line",
    title: "Start the Conversation",
    desc: "Submit a partnership inquiry or schedule an initial conversation with our team. We want to understand your organization, your mission, and your goals before anything else.",
    detail: [
      "Submit a partnership inquiry form",
      "Schedule an introductory call",
      "Share your organization&apos;s background and goals",
    ],
  },
  {
    num: "02",
    icon: "ri-focus-3-line",
    title: "Align on Goals &amp; Opportunity",
    desc: "Together, we explore where our missions intersect and identify the most meaningful collaboration pathways. We take a thoughtful, structured approach to ensure genuine alignment.",
    detail: [
      "Explore shared values and mission alignment",
      "Identify collaboration opportunities",
      "Define mutual goals and expected outcomes",
    ],
  },
  {
    num: "03",
    icon: "ri-route-line",
    title: "Build a Structured Collaboration Pathway",
    desc: "Once aligned, we develop a clear, structured partnership framework &mdash; with defined roles, timelines, and shared accountability for long-term impact.",
    detail: [
      "Develop a partnership framework",
      "Define roles, responsibilities, and timelines",
      "Launch and grow the collaboration together",
    ],
  },
];

export default function PartnershipProcess() {
  return (
    <section className="py-24 px-6 bg-[#1A4D3C]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            How It Works
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            How Partnership Engagement Works
          </h2>
          <p className="text-white/65 text-base leading-relaxed">
            Our partnership process is simple, structured, and relationship-driven. We move at the pace of trust &mdash; not urgency.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-14 left-[calc(16.67%+1rem)] right-[calc(16.67%+1rem)] h-px bg-[#C9A961]/25" />

          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col items-center text-center">
              {/* Step circle */}
              <div className="relative mb-8">
                <div className="w-28 h-28 rounded-full border-2 border-[#C9A961]/30 flex items-center justify-center bg-[#0D2E1E]">
                  <div className="w-20 h-20 rounded-full bg-[#C9A961]/10 flex items-center justify-center">
                    <i className={`${step.icon} text-[#C9A961] text-2xl`} />
                  </div>
                </div>
                <span className="absolute -top-2 -right-2 font-['Cormorant_Garamond'] text-lg font-bold text-[#C9A961]/50">
                  {step.num}
                </span>
              </div>

              <h3
                className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-3"
                dangerouslySetInnerHTML={{ __html: step.title }}
              />
              <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
                {step.desc}
              </p>

              <ul className="space-y-2 text-left w-full max-w-xs">
                {step.detail.map((d, j) => (
                  <li key={j} className="flex items-start gap-2.5">
                    <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#C9A961] text-sm" />
                    </div>
                    <span
                      className="text-white/55 text-xs leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: d }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
